import React from 'react';
import { Badge, BadgeModifier } from './index';
import { DateFormat } from '../DateFormat';
import { useSonTranslation } from '../../../translation/useSonTranslation';

export enum BADGE_STATUS {
  DRAFT = 'draft',
  ARCHIVED = 'archived',
}

type StatusBadge = {
  status: BADGE_STATUS;
  archiveDate?: string;
};

/**
 * Badge to display status information for archived/draft versions.
 */
export function StatusBadge({ status, archiveDate }: StatusBadge) {
  const { t } = useSonTranslation('StatusBadge');

  const modifierDraft = [
    BadgeModifier.STATUS,
    BadgeModifier.HIGHLIGHT,
    BadgeModifier.SMALL_FONT,
    BadgeModifier.PADDING_TOP_1,
  ];
  const modifierArchived = [
    BadgeModifier.STATUS,
    BadgeModifier.INACTIVE,
    BadgeModifier.SMALL_FONT,
    BadgeModifier.PADDING_TOP_1,
  ];

  return (
    <p className="badge__definition">
      {/* please keep the whitespace in the following line for copy&paste reasons */}{' '}
      <dfn className="invisible">{t('state')}: </dfn>
      <Badge modifier={status === BADGE_STATUS.DRAFT ? modifierDraft : modifierArchived}>
        {status === BADGE_STATUS.ARCHIVED && archiveDate ? (
          <>
            {t(`status.${status}On`)}&nbsp;
            <DateFormat date={archiveDate} />
          </>
        ) : (
          t(`status.${status}`)
        )}
      </Badge>
    </p>
  );
}
